import { Button } from '@/components/ui/button';
import { useNavigate } from '@tanstack/react-router';
import { AlertTriangle } from 'lucide-react';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="flex justify-center">
          <div className="rounded-full bg-yellow-100 p-3">
            <AlertTriangle className="h-12 w-12 text-yellow-600" />
          </div>
        </div>
        <h1 className="text-3xl font-bold tracking-tight">Access Denied</h1>
        <p className="text-lg text-gray-600">
          You don't have permission to access this page.
        </p>
        <div className="flex flex-col space-y-4">
          <Button onClick={() => navigate({ to: '/' })}>
            Return to Dashboard
          </Button>
          <Button variant="outline" onClick={() => navigate({ to: '/login' })}>
            Sign in with a different account
          </Button>
        </div>
      </div>
    </div>
  );
}
